import { render } from "./CreditRequests.vue?vue&type=template&id=d5287626&scoped=true"
import script from "./CreditRequests.vue?vue&type=script&lang=js"
export * from "./CreditRequests.vue?vue&type=script&lang=js"

import "./CreditRequests.vue?vue&type=style&index=0&id=d5287626&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5287626"]])

export default __exports__